import { Ellipsis } from 'portaltransparencia-common/components/Ellipsis.react';
import NumberFormatter from 'portaltransparencia-common/components/NumberFormatter.react.js';
import TableHeader from 'portaltransparencia-common/components/TableHeader.react';
import TableHeaderItem from 'portaltransparencia-common/components/TableHeaderItem.react';
import { List, Map } from 'immutable';
import PropTypes from 'prop-types';
import React from 'react';

export const ESFERA_ESTADO = 1;
export const ESFERA_MUNICIPIO = 2;
export const ESFERA_FEDERAL = 4;

const ROTA_POR_ESFERA = {
  [ESFERA_ESTADO]: 'emendas-estaduais',
  [ESFERA_MUNICIPIO]: 'emendas-municipais',
  [ESFERA_FEDERAL]: 'emendas-federais'
};

export function codigoEsfera(esferaGoverno) {
  if (esferaGoverno === null || esferaGoverno === undefined) {
    return null;
  }

  const codigo = Map.isMap(esferaGoverno)
    ? esferaGoverno.get('codigo')
    : esferaGoverno;

  return codigo === null || codigo === undefined ? null : Number(codigo);
}

export function rotaDetalheEmenda(esferaGoverno) {
  return ROTA_POR_ESFERA[codigoEsfera(esferaGoverno)];
}

function EmendaEmpenhoRow({ data, onViewEmenda, onViewEmpenho }) {
  const emenda = `${data.get('numeroEmenda')}/${data.get('anoEmenda')}`;
  const empenho = `${data.get('numeroEmpenho')}/${data.get('anoEmpenho')}`;
  const rotaEmenda = rotaDetalheEmenda(data.get('esferaGoverno'));

  return (
    <tr>
      <td>
        {rotaEmenda ? (
          <a style={{ cursor: 'pointer' }} onClick={() => onViewEmenda(data)}>
            {emenda}
          </a>
        ) : (
          emenda
        )}
      </td>
      <td>{data.get('autoria')}</td>
      <td>{data.get('tipoTransferencia')}</td>
      <td title={data.get('complementoHistorico')}>
        <Ellipsis value={data.get('complementoHistorico')} maxLength={160} />
      </td>
      <td>
        {data.get('fornecedorDocumento')} - {data.get('fornecedorNome')}
      </td>
      <td>
        <a style={{ cursor: 'pointer' }} onClick={() => onViewEmpenho(data)}>
          {empenho}
        </a>
      </td>
      <td className="right">
        <NumberFormatter value={data.get('empenhado')} />
      </td>
      <td className="right">
        <NumberFormatter value={data.get('liquidado')} />
      </td>
      <td className="right">
        <NumberFormatter value={data.get('retido')} />
      </td>
      <td className="right">
        <NumberFormatter value={data.get('pago')} />
      </td>
    </tr>
  );
}

EmendaEmpenhoRow.propTypes = {
  data: PropTypes.instanceOf(Map).isRequired,
  onViewEmenda: PropTypes.func.isRequired,
  onViewEmpenho: PropTypes.func.isRequired
};

export default function EmendaEmpenhosTable({
  page,
  totalizador,
  searchWithPage,
  onViewEmenda,
  onViewEmpenho
}) {
  const content = page.get('content', List());

  return (
    <div className="panel-table-outer">
      <table className="panel-table striped fancy">
        <TableHeader
          text="Não foram encontrados empenhos vinculados a emendas parlamentares."
          empty={content.isEmpty()}
        >
          <tr>
            <TableHeaderItem
              field="emendaParlamentar.numero"
              label="Emenda"
              page={page}
              searchWithPage={searchWithPage}
            />
            <th>Autoria</th>
            <TableHeaderItem
              field="emendaParlamentar.tipoTransferencia"
              label="Tipo de Transferência"
              page={page}
              searchWithPage={searchWithPage}
            />
            <TableHeaderItem
              field="complementoHistorico"
              label="Despesa/Objeto Gasto"
              page={page}
              searchWithPage={searchWithPage}
            />
            <TableHeaderItem
              field="credor.cnpjCpf"
              label="Fornecedor"
              page={page}
              searchWithPage={searchWithPage}
            />
            <TableHeaderItem
              field="numeroEmpenho"
              label="Empenho"
              page={page}
              searchWithPage={searchWithPage}
            />
            <th className="right">Valor Empenhado</th>
            <th className="right">Valor Liquidado</th>
            <th className="right">Valor Retido</th>
            <th className="right">
              Valor <br /> Pago
            </th>
          </tr>
        </TableHeader>
        <tbody>
          {content.map(data => (
            <EmendaEmpenhoRow
              key={data.get('idEmpenho')}
              data={data}
              onViewEmenda={onViewEmenda}
              onViewEmpenho={onViewEmpenho}
            />
          ))}
        </tbody>
        {!content.isEmpty() && (
          <tfoot>
            <tr>
              <td colSpan={6} />
              <td className="right">
                <span>Total Empenhado: </span>
                <br />
                <NumberFormatter
                  value={totalizador.get('valorTotalEmpenhado')}
                />
              </td>
              <td className="right">
                <span>Total Liquidado: </span>
                <br />
                <NumberFormatter
                  value={totalizador.get('valorTotalLiquidado')}
                />
              </td>
              <td className="right">
                <span>Total Retido: </span>
                <br />
                <NumberFormatter value={totalizador.get('valorTotalRetido')} />
              </td>
              <td className="right">
                <span>
                  Total
                  <br />
                  Pago:
                </span>
                <br />
                <NumberFormatter value={totalizador.get('valorTotalPago')} />
              </td>
            </tr>
          </tfoot>
        )}
      </table>
    </div>
  );
}

EmendaEmpenhosTable.propTypes = {
  page: PropTypes.instanceOf(Map).isRequired,
  totalizador: PropTypes.instanceOf(Map).isRequired,
  searchWithPage: PropTypes.func.isRequired,
  onViewEmenda: PropTypes.func.isRequired,
  onViewEmpenho: PropTypes.func.isRequired
};
